import React, { useState, useRef, useEffect, useMemo } from 'react';
import {
    Search,
    MoreHorizontal,
    ChevronsUpDown,
    ChevronLeft,
    ChevronRight,
    X,
    Copy,
    Funnel,
    ChevronUp,
    ChevronDown,
    LinkIcon,
} from 'lucide-react';
import { useHistory } from 'react-router-dom';

export default function AbbreviationsDictionary() {
}
